<template>
  <page>
    <div>
      <h1>IMPRESSUM</h1>

      <p>
        ANGABE GEMÄß § 5 TMG
        <br><b>Foldaz technologies GmbH</b>
        <br>Oranienstraße 185
        <br>10999 Berlin
      </p>

      <p>
        <b>Vertreten durch:</b>
        <br>Erik Hildenbrand, Joerg Hildenbrand, Tobias Raddatz
      </p>

      <p>
        <b>Kontakt:</b>
        <br>Telefon: <a href="tel:+49 175 222 05 86">+49 175 222 05 86</a>
        <br>Telefax: <a href="tel:+49 30 2759 2596">+49 30 2759 2596</a>
        <br>E-Mail: <a href="mailto:hello@foldaz.com">hello@foldaz.com</a>
      </p>

      <p>
        <b>Registereintrag:</b>
        <br>Eintragung im Handelsregister.
        <br>Registergericht: Berlin - Amtsgericht Charlottenburg Registernummer: HRB 157943
      </p>

      <p>
        <b>Umsatzsteuer-ID:</b>
        <br>Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz: (neu)
      </p>
    </div>
  </page>
</template>

<script>
import PageMixin from '@/mixins/pages/Page'

export default {
  name: 'ImprintDE',
  mixins: [PageMixin],
  created () {
    this.$emit('loadingDone')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/static/de/Imprint.vue